var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnclosureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.4,
    height: 38.8,
    viewBox: "0 0 72.4 38.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.7,0H60.1c-0.6,0-1.1,0.3-1.4,0.7l-2.9,4.2H16.6l-2.9-4.2C13.4,0.3,12.9,0,12.4,0H1.7C0.8,0,0,0.8,0,1.7v35.5 c0,0.9,0.8,1.7,1.7,1.7h69c0.9,0,1.7-0.8,1.7-1.7V1.7C72.4,0.8,71.7,0,70.7,0z M16,30c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7 V16.1c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.7,1.7,1.7V30z M26.5,30c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7V16.1 c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.7,1.7,1.7V30z M37,30c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7V16.1c0-0.9,0.8-1.7,1.7-1.7 c0.9,0,1.7,0.7,1.7,1.7V30z M47.4,30c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7V16.1c0-0.9,0.8-1.7,1.7-1.7 c0.9,0,1.7,0.7,1.7,1.7V30z M57.9,30c0,0.9-0.8,1.7-1.7,1.7S54.6,31,54.6,30V16.1c0-0.9,0.8-1.7,1.7-1.7s1.7,0.7,1.7,1.7V30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnclosureIcon);
export default __webpack_public_path__ + "static/media/enclosure-icon.70f4e8660928794d62475014321e60df.svg";
export { ForwardRef as ReactComponent };